import { render, staticRenderFns } from "./mapData.vue?vue&type=template&id=12fec553&scoped=true"
import script from "./mapData.vue?vue&type=script&lang=js"
export * from "./mapData.vue?vue&type=script&lang=js"
import style0 from "./mapData.vue?vue&type=style&index=0&id=12fec553&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fec553",
  null
  
)

export default component.exports